import { featureFlags, permissions } from '@dvag/dfs-constant-config';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import { useGetPolicies } from './useGetPolicies';

type Permission = (typeof permissions)[keyof typeof permissions];

export const usePermission = (permission: Permission, zobPermission: Permission) => {
  const useNewPermissionsApi = useFeatureIsOn(featureFlags.canUsePermissionsApi);
  const hasZobPermission = useFeatureIsOn(zobPermission);
  const hasPermission = !!permission;

  const policies = useGetPolicies({
    enabled: useNewPermissionsApi && hasPermission,
  });

  if (!useNewPermissionsApi) {
    return hasZobPermission;
  }

  const policyList = policies.data?.policies;

  return Array.isArray(policyList) && policyList.includes(permission);
};
